var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmsWhiteIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9036 0H8.09835C3.6325 0 0 3.63251 0 8.09835V10.2235C0 14.6883 3.6325 18.3208 8.09738 18.3208H8.41206L7.88759 21.1734C7.806 21.6202 8.0022 22.065 8.38876 22.3059C8.56844 22.4176 8.76852 22.473 8.96957 22.473C9.20073 22.473 9.43091 22.3992 9.62614 22.2535L14.8884 18.3218H18.9026C23.3675 18.3218 27 14.6893 27 10.2244V8.09835C27.001 3.63251 23.3685 0 18.9036 0ZM25.2527 10.2225C25.2527 13.7239 22.404 16.5726 18.9026 16.5726H14.598C14.4096 16.5726 14.226 16.6338 14.0745 16.7464L9.90683 19.8603L10.3216 17.6041C10.3682 17.3486 10.2992 17.0864 10.1331 16.8863C9.96705 16.6872 9.72132 16.5716 9.462 16.5716H8.09738C4.59599 16.5716 1.74729 13.7229 1.74729 10.2215V8.09835C1.74729 4.59696 4.59599 1.74826 8.09738 1.74826H18.9026C22.404 1.74826 25.2527 4.59696 25.2527 8.09835V10.2225Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39173 7.75342C8.61473 7.75342 7.98535 8.38279 7.98535 9.1598C7.98535 9.93681 8.61473 10.5662 9.39173 10.5662C10.1687 10.5662 10.7981 9.93681 10.7981 9.1598C10.7971 8.38279 10.1678 7.75342 9.39173 7.75342Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5006 7.75342C13.7236 7.75342 13.0942 8.38279 13.0942 9.1598C13.0942 9.93681 13.7236 10.5662 14.5006 10.5662C15.2776 10.5662 15.907 9.93681 15.907 9.1598C15.907 8.38279 15.2776 7.75342 14.5006 7.75342Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6095 7.75342C18.8325 7.75342 18.2031 8.38279 18.2031 9.1598C18.2031 9.93681 18.8325 10.5662 19.6095 10.5662C20.3865 10.5662 21.0159 9.93681 21.0159 9.1598C21.0159 8.38279 20.3865 7.75342 19.6095 7.75342Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsWhiteIcon01);
export default __webpack_public_path__ + "static/media/sms-white-icon01.bc2d1a2ea97440981308d874744b5030.svg";
export { ForwardRef as ReactComponent };